/**
 * Ações do menu de contexto da nota fiscal de entrada.
 * Enum numérico e tipado para evitar magic string no roteamento das ações da listagem.
 */
export enum AcaoNotaFiscalEntradaEnum {
  TratarNota = 1,
  ContinuarAssociacaoItens = 2,
  Editar = 3,
  Visualizar = 4,
  RegistrarCiencia = 5,
  ConsultarXml = 6,
  CopiarChaveAcesso = 8,
  FormacaoPrecos = 9,
  Marcadores = 10,
  VerDanfe = 11,
  BaixarXml = 12,
  Manifestar = 13,
  ExcluirEstoque = 14,
  ExcluirFinanceiro = 15,
  ReabrirParaEdicao = 16,
  ExcluirNota = 17,
  LancarEstoque = 18,
  LancarFinanceiro = 19,
  VerHistorico = 20,
}
